<template>
    <div>
        <template v-if="retailerPayments === true">
            <div v-show="isDataTableLoading === false">
                <div class="page-top mb-1 mb-3 align-left clearfix">
                    <h1> Retailer Payments</h1>
                </div>
                <div class="page-top mb-1 mb-3 clearfix">
                    <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="new-tab" data-toggle="tab" href="#new" role="tab"
                                aria-controls="new" aria-selected="true" @click="reloadList('new')">New
                                ({{new_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="inprocess-tab" data-toggle="tab" href="#inprocess" role="tab"
                                aria-controls="inprocess" aria-selected="false" @click="reloadList('inprocess')">In
                                Process ({{inprocess_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="processed-tab" data-toggle="tab" href="#processed" role="tab"
                                aria-controls="rejected" aria-selected="false"
                                @click="reloadList('processed')">Processed ({{processed_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="disapproved-tab" data-toggle="tab" href="#disapproved" role="tab"
                                aria-controls="disapproved" aria-selected="false"
                                @click="reloadList('disapproved')">Disapproved ({{disapproved_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="error-tab" data-toggle="tab" href="#error" role="tab"
                                aria-controls="error" aria-selected="false" @click="reloadList('error')">Error
                                ({{error_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="archived-tab" data-toggle="tab" href="#archived" role="tab"
                                aria-controls="archived" aria-selected="false" @click="reloadList('archived')">Archived
                                ({{archived_batch_count}})</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="deleted-tab" data-toggle="tab" href="#deleted" role="tab"
                                aria-controls="deleted" aria-selected="false" @click="reloadList('deleted')">Deleted
                                ({{deleted_batch_count}})</a>
                        </li>
                    </ul>
                    <router-link to="/retailerPaymentBulkUpload" class="btn btn-primary float-right mr-1">New Batch
                    </router-link>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="vendorPaymentNewTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Tiime Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="inprocess" role="tabpanel" aria-labelledby="inprocess-tab">
                        <table id="vendorPaymentInProcessTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Tiime Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="processed" role="tabpanel" aria-labelledby="processed-tab">
                        <table id="vendorPaymentProcessTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Tiime Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="disapproved" role="tabpanel" aria-labelledby="disapproved-tab">
                        <table id="vendorPaymentDisapproveTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Tiime Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="error" role="tabpanel" aria-labelledby="error-tab">
                        <table id="vendorPaymentErrorTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Tiime Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="archived" role="tabpanel" aria-labelledby="archived-tab">
                        <table id="vendorPaymentArchiveTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Tiime Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="deleted" role="tabpanel" aria-labelledby="deleted-tab">
                        <table id="vendorPaymentDeletedTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Tiime Period</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
            <preLoader v-show="isDataTableLoading === true"></preLoader>
        </template>

        <template v-else-if="retailerPayments === false">
            <notAllowed></notAllowed>
        </template>

        <template v-else-if="retailerPayments === null">
            <preLoader></preLoader>
        </template>
    </div>
</template>
<script>
var gThat = null;
export default {
	data() {
		return {
			data: null,
			new_batch_count: "",
			inprocess_batch_count: "",
			processed_batch_count: "",
			disapproved_batch_count: "",
			error_batch_count: "",
			deleted_batch_count:'',
			archived_batch_count: "",
			retailerPayments: null,
			currentActiveTab : 'new',
			isDataTableLoading : false,
			newtab : null,
			inprocesstab : null,
			processtab : null,
			disapprovedtab : null,
			errortab : null,
			archivetab : null,
			deletedtab : null,
		};
	},
	beforeMount() {
		this.$Progress.start();

		$("#vendorPaymentNewTable").dataTable({
			sDom:'<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
		});
	
		$("#vendorPaymentInProcessTable").dataTable({
			sDom:'<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
		});
	
		$("#vendorPaymentProcessTable").dataTable({
			sDom:'<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
		});
	
		$("#vendorPaymentDisapproveTable").dataTable({
			sDom:'<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
		});
	
		$("#vendorPaymentErrorTable").dataTable({
			sDom:'<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
		});
	
		$("#vendorPaymentArchiveTable").dataTable({
			sDom:'<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
		});
	
		$("#vendorPaymentDeletedTable").dataTable({
			sDom:'<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r'
		});

	},
	mounted() {
	gThat = this;
	this.$Progress.start();
	this.can("retailer_payments")
		.then(result => {
			this.retailerPayments = result.retailer_payments;
		})
		.then(result => {
			if (this.retailerPayments === true) {
				gThat.counts();
				gThat.vendorPaymentNewList();
				gThat.vendorPaymentInProcessList();
				gThat.vendorPaymentProcessList();
				gThat.vendorPaymentErrorList();
				gThat.vendorPaymentDisapproveList();
				gThat.vendorPaymentArchiveList();
				gThat.vendorPaymentDeletedList();
			}
		});
	},

	methods: {
		counts : function(){
			axios.get("/api/listVendorPayments")
			.then(res => {
				if (res.status == 200) {
					this.new_batch_count = res.data.newcount;
					this.inprocess_batch_count = res.data.inprocesscount;
					this.processed_batch_count = res.data.processedcount;
					this.disapproved_batch_count = res.data.disapprovedcount;
					this.error_batch_count = res.data.errorcount;
					this.archived_batch_count = res.data.archivedcount;
					this.deleted_batch_count = res.data.deletedcount;
					this.$Progress.finish();
				} else {
					this.$Progress.fail();
				}
			})
			.catch(err => {
				this.$Progress.fail();
			});
		},

		vendorPaymentNewList: function() {
			this.newtab = $("#vendorPaymentNewTable").DataTable({
				processing: true,
				serverSide: true,
				searching: false,
				aaSearching: false,
				autoWidth: false,
				paging: true,
				stateSave: true,
				bLengthChange: true,
				info: true,
				sDom:
					'<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
				ajax: {
					url: "api/getVendorPaymentNewList",
					headers: window.axios.defaults.headers.common,
					dataSrc: "records",
					complete: function(json, type) {
						//type return "success" or "parsererror"
						if (type == "parsererror") {
							gThat.$Progress.fail();
						} else {
							gThat.$Progress.finish();
						}
					}
				},
				deferRender: true,
				columnDefs: [{ className: "text-center", targets: [5] }],
				columns: [
					{ data: "sName",
					render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a class="text-limit text-limit-10" title="'+full["sName"]+'" href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')"><strong class="elisp">'+full["sName"]+'</strong></a>'
							);
						} },
					{
						data: "created",
						mData: "created",
						mRender: function(data, type, full) {
							var date = new Date(full["created"]);
							return moment(date).format("MMM D, Y");
						}
					},
					{
						name: "timeperiod",
						mData: "timeperiod",
						orderable: false,
						mRender: function(data, type, full) {
							var month = full["month"];
							//              if(month == null){ // new case check for onetime or timeperiod
							var payroll_type = full["payroll_type"];
							var payroll_frequency = full["payroll_frequency"];
							if (
								payroll_type == "DISBURSEMENT" ||
								payroll_frequency == "ONETIME"
							) {
								var date = full["onetime_date"];
								if (payroll_type == "VENDOR") {
									date = full["created_at"];
								}
								return "" + moment(date).format("MMM D, Y") + "";
							} else {
								var date =
									moment(full["fromdate"]).format("MMM D, Y") +
									" - " +
									moment(full["todate"]).format("MMM D, Y");
								return "" + date + "";
							}
						}
					},
					{
						name: "amount",
						mData: "amount",
						render: $.fn.dataTable.render.number(",")
					},
					{
						name: "pStatus",
						mData: "pStatus",
						mRender: function(data, type, full) {
							var status = full["pStatus"];
							if (status == 1) {
								var to_return =
									'<span class="status uploaded">Uploaded </span>';
							} else if (status == 2) {
								var to_return =
									'<span class="status uploaded">Under Review </span>';
							} else if (status == 3) {
								var to_return = '<span class="status checked"> Checked </span>';
							} else if (status == 4) {
								var to_return = '<span class="status partial">Partial  </span>';
							} else if (status == 5) {
								var to_return =
									'<span class="status processing"> Processed </span>';
							} else if (status == 6) {
								var to_return =
									'<span class="status disapproved">Disapproved </span>';
							} else if (status == 7) {
								var to_return = '<span class="status flagged"> Flagged </span>';
							} else if (status == 8) {
								var to_return = '<span class="status">Archive  </span>';
							} else if (status == 10) {
								var to_return =
									'<span class="status processing"> In Process  </span>';
							} else if (status == 11) {
								var to_return =
									'<span class="status disapproved"> Error  </span>';
							}
							var canEdit = full["canEdit"];
							var status = full["pStatus"];
							var id = full["bId"];
							var userUrl = "/viewRetailerPaymentSheet/" + id;

							to_return =
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								userUrl +
								"')\">" +
								to_return +
								"</a>";
							return to_return;
						}
					},
					{
						data: "id",
						sorting: true,
						render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +$url +'\')" class="view"><span class="status processing"> Process </span></a>'
							);
						},
						visible: gThat.crud_region
					}
				],
				drawCallback: function() {
					$(".action").tooltip();
				},
				order: [[1, "desc"]]
			});
		},
		vendorPaymentInProcessList: function() {
			this.inprocesstab = $("#vendorPaymentInProcessTable").DataTable({
				processing: true,
				serverSide: true,
				searching: false,
				aaSearching: false,
				autoWidth: false,
				paging: true,
				stateSave: true,
				bLengthChange: true,
				info: true,
				sDom:
					'<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
				ajax: {
					url: "api/getVendorPaymentInProcessList",
					headers: window.axios.defaults.headers.common,
					dataSrc: "records",
					complete: function(json, type) {
						//type return "success" or "parsererror"
						if (type == "parsererror") {
							gThat.$Progress.fail();
						} else {
							gThat.$Progress.finish();
						}
					}
				},
				deferRender: true,
				columnDefs: [{ className: "text-center", targets: [5] }],
				columns: [
					{ data: "sName",
					render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a class="text-limit text-limit-10" title="'+full["sName"]+'" href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')"><strong class="elisp">'+full["sName"]+'</strong></a>'
							);
						}  },
					{
						data: "created",
						mData: "created",
						mRender: function(data, type, full) {
							var date = new Date(full["created"]);
							return moment(date).format("MMM D, Y");
						}
					},
					{
						name: "timeperiod",
						mData: "timeperiod",
						orderable: false,
						mRender: function(data, type, full) {
							var month = full["month"];
							//              if(month == null){ // new case check for onetime or timeperiod
							var payroll_type = full["payroll_type"];
							var payroll_frequency = full["payroll_frequency"];
							if (
								payroll_type == "DISBURSEMENT" ||
								payroll_frequency == "ONETIME"
							) {
								var date = full["onetime_date"];
								if (payroll_type == "VENDOR") {
									date = full["created_at"];
								}
								return "" + moment(date).format("MMM D, Y") + "";
							} else {
								var date =
									moment(full["fromdate"]).format("MMM D, Y") +
									" - " +
									moment(full["todate"]).format("MMM D, Y");
								return "" + date + "";
							}
						}
					},
					{
						name: "amount",
						mData: "amount",
						render: $.fn.dataTable.render.number(",")
					},
					{
						name: "pStatus",
						mData: "pStatus",
						mRender: function(data, type, full) {
							var status = full["pStatus"];
							if (status == 1) {
								var to_return =
									'<span class="status uploaded">Uploaded </span>';
							} else if (status == 2) {
								var to_return =
									'<span class="status uploaded">Under Review </span>';
							} else if (status == 3) {
								var to_return = '<span class="status checked"> Checked </span>';
							} else if (status == 4) {
								var to_return = '<span class="status partial">Partial  </span>';
							} else if (status == 5) {
								var to_return =
									'<span class="status processing"> Processed </span>';
							} else if (status == 6) {
								var to_return =
									'<span class="status disapproved">Disapproved </span>';
							} else if (status == 7) {
								var to_return = '<span class="status flagged"> Flagged </span>';
							} else if (status == 8) {
								var to_return = '<span class="status">Archive  </span>';
							} else if (status == 10) {
								var to_return =
									'<span class="status processing"> In Process  </span>';
							} else if (status == 11) {
								var to_return =
									'<span class="status disapproved"> Error  </span>';
							}
							var canEdit = full["canEdit"];
							var status = full["pStatus"];
							var id = full["bId"];
							var userUrl = "/viewRetailerPaymentSheet/" + id;

							to_return =
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								userUrl +
								"')\">" +
								to_return +
								"</a>";
							return to_return;
						}
					},
					{
						data: "id",
						sorting: true,
						render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')" class="action view" data-toggle="tooltip" data-placement="top" title="View"><i class="far fa-eye"></i></a>'
							);
						},
						visible: gThat.crud_region
					}
				],
				drawCallback: function() {
					$(".action").tooltip();
				},
				order: [[1, "desc"]]
			});
		},
		vendorPaymentProcessList: function() {
			this.processtab = $("#vendorPaymentProcessTable").DataTable({
				processing: true,
				serverSide: true,
				searching: false,
				aaSearching: false,
				autoWidth: false,
				paging: true,
				stateSave: true,
				bLengthChange: true,
				info: true,
				sDom:
					'<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
				ajax: {
					url: "api/getVendorPaymentProcessedList",
					headers: window.axios.defaults.headers.common,
					dataSrc: "records",
					complete: function(json, type) {
						//type return "success" or "parsererror"
						if (type == "parsererror") {
							gThat.$Progress.fail();
						} else {
							gThat.$Progress.finish();
						}
					}
				},
				deferRender: true,
				columnDefs: [{ className: "text-center", targets: [2] }],
				columns: [
					{ data: "sName",
					render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a class="text-limit text-limit-10" title="'+full["sName"]+'" href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')"><strong class="elisp">'+full["sName"]+'</strong></a>'
							);
						}  },
					{
						data: "created",
						mData: "created",
						mRender: function(data, type, full) {
							var date = new Date(full["created"]);
							return moment(date).format("MMM D, Y");
						}
					},
					{
						name: "timeperiod",
						mData: "timeperiod",
						orderable: false,
						mRender: function(data, type, full) {
							var month = full["month"];
							//              if(month == null){ // new case check for onetime or timeperiod
							var payroll_type = full["payroll_type"];
							var payroll_frequency = full["payroll_frequency"];
							if (
								payroll_type == "DISBURSEMENT" ||
								payroll_frequency == "ONETIME"
							) {
								var date = full["onetime_date"];
								if (payroll_type == "VENDOR") {
									date = full["created_at"];
								}
								return "" + moment(date).format("MMM D, Y") + "";
							} else {
								var date =
									moment(full["fromdate"]).format("MMM D, Y") +
									" - " +
									moment(full["todate"]).format("MMM D, Y");
								return "" + date + "";
							}
						}
					},
					{
						name: "amount",
						mData: "amount",
						render: $.fn.dataTable.render.number(",")
					},
					{
						name: "pStatus",
						mData: "pStatus",
						mRender: function(data, type, full) {
							var status = full["pStatus"];
							if (status == 1) {
								var to_return =
									'<span class="status uploaded">Uploaded </span>';
							} else if (status == 2) {
								var to_return =
									'<span class="status uploaded">Under Review </span>';
							} else if (status == 3) {
								var to_return = '<span class="status checked"> Checked </span>';
							} else if (status == 4) {
								var to_return = '<span class="status partial">Partial  </span>';
							} else if (status == 5) {
								var to_return =
									'<span class="status processing"> Processed </span>';
							} else if (status == 6) {
								var to_return =
									'<span class="status disapproved">Disapproved </span>';
							} else if (status == 7) {
								var to_return = '<span class="status flagged"> Flagged </span>';
							} else if (status == 8) {
								var to_return = '<span class="status">Archive  </span>';
							} else if (status == 10) {
								var to_return =
									'<span class="status processing"> In Process  </span>';
							} else if (status == 11) {
								var to_return =
									'<span class="status disapproved"> Error  </span>';
							}
							var canEdit = full["canEdit"];
							var status = full["pStatus"];
							var id = full["bId"];
							var userUrl = "/viewRetailerPaymentSheet/" + id;

							to_return =
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								userUrl +
								"')\">" +
								to_return +
								"</a>";
							return to_return;
						}
					},
					{
						data: "id",
						sorting: true,
						render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')" class="action view" data-toggle="tooltip" data-placement="top" title="View"><i class="far fa-eye"></i></a>'
							);
						},
						visible: gThat.crud_region
					}
				],
				drawCallback: function() {
					$(".action").tooltip();
				},
				order: [[1, "desc"]]
			});
		},
		vendorPaymentErrorList: function() {
			this.errortab = $("#vendorPaymentErrorTable").DataTable({
				processing: true,
				serverSide: true,
				searching: false,
				aaSearching: false,
				autoWidth: false,
				paging: true,
				stateSave: true,
				bLengthChange: true,
				info: true,
				sDom:
					'<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
				ajax: {
					url: "api/getVendorPaymentErrorList",
					headers: window.axios.defaults.headers.common,
					dataSrc: "records",
					complete: function(json, type) {
						//type return "success" or "parsererror"
						if (type == "parsererror") {
							gThat.$Progress.fail();
						} else {
							gThat.$Progress.finish();
						}
					}
				},
				deferRender: true,
				columnDefs: [{ className: "text-center", targets: [5] }],
				columns: [
					{ data: "sName",
					render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a class="text-limit text-limit-10" title="'+full["sName"]+'" href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')"><strong class="elisp">'+full["sName"]+'</strong></a>'
							);
						}  },
					{
						data: "created",
						mData: "created",
						mRender: function(data, type, full) {
							var date = new Date(full["created"]);
							return moment(date).format("MMM D, Y");
						}
					},
					{
						name: "timeperiod",
						mData: "timeperiod",
						orderable: false,
						mRender: function(data, type, full) {
							var month = full["month"];
							//              if(month == null){ // new case check for onetime or timeperiod
							var payroll_type = full["payroll_type"];
							var payroll_frequency = full["payroll_frequency"];
							if (
								payroll_type == "DISBURSEMENT" ||
								payroll_frequency == "ONETIME"
							) {
								var date = full["onetime_date"];
								if (payroll_type == "VENDOR") {
									date = full["created_at"];
								}
								return "" + moment(date).format("MMM D, Y") + "";
							} else {
								var date =
									moment(full["fromdate"]).format("MMM D, Y") +
									" - " +
									moment(full["todate"]).format("MMM D, Y");
								return "" + date + "";
							}
						}
					},
					{
						name: "amount",
						mData: "amount",
						render: $.fn.dataTable.render.number(",")
					},
					{
						name: "pStatus",
						mData: "pStatus",
						mRender: function(data, type, full) {
							var status = full["pStatus"];
							if (status == 1) {
								var to_return =
									'<span class="status uploaded">Uploaded </span>';
							} else if (status == 2) {
								var to_return =
									'<span class="status uploaded">Under Review </span>';
							} else if (status == 3) {
								var to_return = '<span class="status checked"> Checked </span>';
							} else if (status == 4) {
								var to_return = '<span class="status partial">Partial  </span>';
							} else if (status == 5) {
								var to_return =
									'<span class="status processing"> Processed </span>';
							} else if (status == 6) {
								var to_return =
									'<span class="status disapproved">Disapproved </span>';
							} else if (status == 7) {
								var to_return = '<span class="status flagged"> Flagged </span>';
							} else if (status == 8) {
								var to_return = '<span class="status">Archive  </span>';
							} else if (status == 10) {
								var to_return =
									'<span class="status processing"> In Process  </span>';
							} else if (status == 11) {
								var to_return =
									'<span class="status disapproved"> Error  </span>';
							}
							var canEdit = full["canEdit"];
							var status = full["pStatus"];
							var id = full["bId"];
							var userUrl = "/viewRetailerPaymentSheet/" + id;

							to_return =
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								userUrl +
								"')\" >" +
								to_return +
								"</a>";
							return to_return;
						}
					},
					{
						data: "id",
						sorting: true,
						render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')" class="action view" data-toggle="tooltip" data-placement="top" title="View"><i class="far fa-eye"></i></a>'
							);
						},
						visible: gThat.crud_region
					}
				],
				drawCallback: function() {
					$(".action").tooltip();
				},
				order: [[1, "desc"]]
			});
		},
		vendorPaymentDeletedList: function() {
			this.deletedtab = $("#vendorPaymentDeletedTable").DataTable({
				processing: true,
				serverSide: true,
				searching: false,
				aaSearching: false,
				autoWidth: false,
				paging: true,
				stateSave: true,
				bLengthChange: true,
				info: true,
				sDom:
					'<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
				ajax: {
					url: "api/getVendorPaymentDeletedList",
					headers: window.axios.defaults.headers.common,
					dataSrc: "records",
					complete: function(json, type) {
						//type return "success" or "parsererror"
						if (type == "parsererror") {
							gThat.$Progress.fail();
						} else {
							gThat.$Progress.finish();
						}
					}
				},
				deferRender: true,
				columnDefs: [{ className: "text-center", targets: [5] }],
				columns: [
					{ data: "sName",
					render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a class="text-limit text-limit-10" title="'+full["sName"]+'" href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')"><strong class="elisp">'+full["sName"]+'</strong></a>'
							);
						}  },
					{
						data: "created",
						mData: "created",
						mRender: function(data, type, full) {
							var date = new Date(full["created"]);
							return moment(date).format("MMM D, Y");
						}
					},
					{
						name: "timeperiod",
						mData: "timeperiod",
						orderable: false,
						mRender: function(data, type, full) {
							var month = full["month"];
							//              if(month == null){ // new case check for onetime or timeperiod
							var payroll_type = full["payroll_type"];
							var payroll_frequency = full["payroll_frequency"];
							if (
								payroll_type == "DISBURSEMENT" ||
								payroll_frequency == "ONETIME"
							) {
								var date = full["onetime_date"];
								if (payroll_type == "VENDOR") {
									date = full["created_at"];
								}
								return "" + moment(date).format("MMM D, Y") + "";
							} else {
								var date =
									moment(full["fromdate"]).format("MMM D, Y") +
									" - " +
									moment(full["todate"]).format("MMM D, Y");
								return "" + date + "";
							}
						}
					},
					{
						name: "amount",
						mData: "amount",
						render: $.fn.dataTable.render.number(",")
					},
					{
						name: "pStatus",
						mData: "pStatus",
						mRender: function(data, type, full) {
							var status = full["pStatus"];
							if (status == 1) {
								var to_return =
									'<span class="status uploaded">Uploaded </span>';
							} else if (status == 2) {
								var to_return =
									'<span class="status uploaded">Under Review </span>';
							} else if (status == 3) {
								var to_return = '<span class="status checked"> Checked </span>';
							} else if (status == 4) {
								var to_return = '<span class="status partial">Partial  </span>';
							} else if (status == 5) {
								var to_return =
									'<span class="status processing"> Processed </span>';
							} else if (status == 6) {
								var to_return =
									'<span class="status disapproved">Disapproved </span>';
							} else if (status == 7) {
								var to_return = '<span class="status flagged"> Flagged </span>';
							} else if (status == 8) {
								var to_return = '<span class="status">Archive  </span>';
							} else if (status == 10) {
								var to_return =
									'<span class="status processing"> In Process  </span>';
							} else if (status == 11) {
								var to_return =
									'<span class="status disapproved"> Error  </span>';
							}
							var canEdit = full["canEdit"];
							var status = full["pStatus"];
							var id = full["bId"];
							var userUrl = "/viewRetailerPaymentSheet/" + id;

							to_return =
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								userUrl +
								"')\">" +
								to_return +
								"</a>";
							return to_return;
						}
					},
					{
						data: "id",
						sorting: true,
						render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;

							return (
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')" class="action view" data-toggle="tooltip" data-placement="top" title="View"><i class="far fa-eye"></i></a>'
							);
						},
						visible: gThat.crud_region
					}
				],
				drawCallback: function() {
					$(".action").tooltip();
				},
				order: [[1, "desc"]]
			});
		},
		vendorPaymentDisapproveList: function() {
			this.disapprovedtab = $("#vendorPaymentDisapproveTable").DataTable({
				processing: true,
				serverSide: true,
				searching: false,
				aaSearching: false,
				autoWidth: false,
				paging: true,
				stateSave: true,
				bLengthChange: true,
				info: true,
				sDom:
					'<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
				ajax: {
					url: "api/getVendorPaymentDisapprovedList",
					headers: window.axios.defaults.headers.common,
					dataSrc: "records",
					complete: function(json, type) {
						//type return "success" or "parsererror"
						if (type == "parsererror") {
							gThat.$Progress.fail();
						} else {
							gThat.$Progress.finish();
						}
					}
				},
				deferRender: true,
				columnDefs: [{ className: "text-center", targets: [5] }],
				columns: [
					{ data: "sName",
					render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a class="text-limit text-limit-10" title="'+full["sName"]+'" href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')"><strong class="elisp">'+full["sName"]+'</strong></a>'
							);
						}  },
					{
						data: "created",
						mData: "created",
						mRender: function(data, type, full) {
							var date = new Date(full["created"]);
							return moment(date).format("MMM D, Y");
						}
					},
					{
						name: "timeperiod",
						mData: "timeperiod",
						orderable: false,
						mRender: function(data, type, full) {
							var month = full["month"];
							//              if(month == null){ // new case check for onetime or timeperiod
							var payroll_type = full["payroll_type"];
							var payroll_frequency = full["payroll_frequency"];
							if (
								payroll_type == "DISBURSEMENT" ||
								payroll_frequency == "ONETIME"
							) {
								var date = full["onetime_date"];
								if (payroll_type == "VENDOR") {
									date = full["created_at"];
								}
								return "" + moment(date).format("MMM D, Y") + "";
							} else {
								var date =
									moment(full["fromdate"]).format("MMM D, Y") +
									" - " +
									moment(full["todate"]).format("MMM D, Y");
								return "" + date + "";
							}
						}
					},
					{
						name: "amount",
						mData: "amount",
						render: $.fn.dataTable.render.number(",")
					},
					{
						name: "pStatus",
						mData: "pStatus",
						mRender: function(data, type, full) {
							var status = full["pStatus"];
							if (status == 1) {
								var to_return =
									'<span class="status uploaded">Uploaded </span>';
							} else if (status == 2) {
								var to_return =
									'<span class="status uploaded">Under Review </span>';
							} else if (status == 3) {
								var to_return = '<span class="status checked"> Checked </span>';
							} else if (status == 4) {
								var to_return = '<span class="status partial">Partial  </span>';
							} else if (status == 5) {
								var to_return =
									'<span class="status processing"> Processed </span>';
							} else if (status == 6) {
								var to_return =
									'<span class="status disapproved">Disapproved </span>';
							} else if (status == 7) {
								var to_return = '<span class="status flagged"> Flagged </span>';
							} else if (status == 8) {
								var to_return = '<span class="status">Archive  </span>';
							} else if (status == 10) {
								var to_return =
									'<span class="status processing"> In Process  </span>';
							} else if (status == 11) {
								var to_return =
									'<span class="status disapproved"> Error  </span>';
							}
							var canEdit = full["canEdit"];
							var status = full["pStatus"];
							var id = full["bId"];
							var userUrl = "/viewRetailerPaymentSheet/" + id;

							to_return =
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								userUrl +
								"')\">" +
								to_return +
								"</a>";
							return to_return;
						}
					},
					{
						data: "id",
						sorting: true,
						render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;

							return (
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')" class="action view" data-toggle="tooltip" data-placement="top" title="View"><i class="far fa-eye"></i></a>'
							);
						},
						visible: gThat.crud_region
					}
				],
				drawCallback: function() {
					$(".action").tooltip();
				},
				order: [[1, "desc"]]
			});
		},
		vendorPaymentArchiveList: function() {
			this.archivetab = $("#vendorPaymentArchiveTable").DataTable({
				processing: true,
				serverSide: true,
				searching: false,
				aaSearching: false,
				autoWidth: false,
				paging: true,
				stateSave: true,
				bLengthChange: true,
				info: true,
				sDom:
					'<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
				ajax: {
					url: "api/getVendorPaymentArchivedList",
					headers: window.axios.defaults.headers.common,
					dataSrc: "records",
					complete: function(json, type) {
						//type return "success" or "parsererror"
						if (type == "parsererror") {
							gThat.$Progress.fail();
						} else {
							gThat.$Progress.finish();
						}
					}
				},
				deferRender: true,
				columnDefs: [{ className: "text-center", targets: [5] }],
				columns: [
					{ data: "sName",
					render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a class="text-limit text-limit-10" title="'+full["sName"]+'" href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')"><strong class="elisp">'+full["sName"]+'</strong></a>'
							);
						}  },
					{
						data: "created",
						mData: "created",
						mRender: function(data, type, full) {
							var date = new Date(full["created"]);
							return moment(date).format("MMM D, Y");
						}
					},
					{
						name: "timeperiod",
						mData: "timeperiod",
						orderable: false,
						mRender: function(data, type, full) {
							var month = full["month"];
							//              if(month == null){ // new case check for onetime or timeperiod
							var payroll_type = full["payroll_type"];
							var payroll_frequency = full["payroll_frequency"];
							if (
								payroll_type == "DISBURSEMENT" ||
								payroll_frequency == "ONETIME"
							) {
								var date = full["onetime_date"];
								if (payroll_type == "VENDOR") {
									date = full["created_at"];
								}
								return "" + moment(date).format("MMM D, Y") + "";
							} else {
								var date =
									moment(full["fromdate"]).format("MMM D, Y") +
									" - " +
									moment(full["todate"]).format("MMM D, Y");
								return "" + date + "";
							}
						}
					},
					{
						name: "amount",
						mData: "amount",
						render: $.fn.dataTable.render.number(",")
					},
					{
						name: "pStatus",
						mData: "pStatus",
						mRender: function(data, type, full) {
							var status = full["pStatus"];
							if (status == 1) {
								var to_return =
									'<span class="status uploaded">Uploaded </span>';
							} else if (status == 2) {
								var to_return =
									'<span class="status uploaded">Under Review </span>';
							} else if (status == 3) {
								var to_return = '<span class="status checked"> Checked </span>';
							} else if (status == 4) {
								var to_return = '<span class="status partial">Partial  </span>';
							} else if (status == 5) {
								var to_return =
									'<span class="status processing"> Processed </span>';
							} else if (status == 6) {
								var to_return =
									'<span class="status disapproved">Disapproved </span>';
							} else if (status == 7) {
								var to_return = '<span class="status flagged"> Flagged </span>';
							} else if (status == 8) {
								var to_return = '<span class="status">Archive  </span>';
							} else if (status == 10) {
								var to_return =
									'<span class="status processing"> In Process  </span>';
							} else if (status == 11) {
								var to_return =
									'<span class="status disapproved"> Error  </span>';
							}
							var canEdit = full["canEdit"];
							var status = full["pStatus"];
							var id = full["bId"];
							var userUrl = "/viewRetailerPaymentSheet/" + id;
							to_return =
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								userUrl +
								"')\">" +
								to_return +
								"</a>";
							return to_return;
						}
					},
					{
						data: "id",
						sorting: true,
						render: function(data, type, full) {
							var id = full["bId"];
							var $url = "/viewRetailerPaymentSheet/" + id;
							return (
								'<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' +
								$url +
								'\')" class="action view" data-toggle="tooltip" data-placement="top" title="View"><i class="far fa-eye"></i></a>'
							);
						},
						visible: gThat.crud_region
					}
				],
				drawCallback: function() {
					$(".action").tooltip();
				},
				order: [[1, "desc"]]
			});
		},
		reloadList(tabClicked){

			switch(tabClicked)
			{
				case 'new':
					if(gThat.currentActiveTab !== 'new')
					{
						gThat.isDataTableLoading = true;

						gThat.newtab.ajax.reload(function(json){
							gThat.new_batch_count 	= json.recordsTotal;
							gThat.isDataTableLoading 	= false;
						}, false);

						gThat.currentActiveTab = 'new';	
					}
				break;

				case 'inprocess':
					if(gThat.currentActiveTab !== 'inprocess')
					{
						gThat.isDataTableLoading = true;

						gThat.inprocesstab.ajax.reload(function(json){
							gThat.inprocess_batch_count 	= json.recordsTotal;
							gThat.isDataTableLoading 		= false;
						}, false);

						gThat.currentActiveTab = 'inprocess';
					}
				break;

				case 'processed':
					if(gThat.currentActiveTab !== 'processed')
					{
						gThat.isDataTableLoading = true;
					
						gThat.processtab.ajax.reload(function(json){
							gThat.processed_batch_count 	= json.recordsTotal;
							gThat.isDataTableLoading 		= false;
						}, false);

						gThat.currentActiveTab = 'processed';
					}
				break;

				case 'disapproved':
					if(gThat.currentActiveTab !== 'disapproved')
					{
						gThat.isDataTableLoading = true;

						gThat.disapprovedtab.ajax.reload(function(json){
							gThat.disapproved_batch_count = json.recordsTotal;
							gThat.isDataTableLoading 		= false;
						}, false);

						gThat.currentActiveTab = 'disapproved';
					}
				break;

				case 'error':
					if(gThat.currentActiveTab !== 'error')
					{
						gThat.isDataTableLoading = true;
			
						gThat.errortab.ajax.reload(function(json){
							gThat.error_batch_count  = json.recordsTotal;
							gThat.isDataTableLoading = false;
						}, false);

						gThat.currentActiveTab = 'error';
					}
				break;

				case 'archived':
					if(gThat.currentActiveTab !== 'archived')
					{
						gThat.isDataTableLoading = true;

						gThat.archivetab.ajax.reload(function(json){
							gThat.archived_batch_count = json.recordsTotal;
							gThat.isDataTableLoading = false;
						}, false);

						gThat.currentActiveTab = 'archived';
					}
				break;

				case 'deleted':
					if(gThat.currentActiveTab !== 'deleted')
					{
						gThat.isDataTableLoading = true;

						gThat.deletedtab.ajax.reload(function(json){
							gThat.deleted_batch_count = json.recordsTotal;
							gThat.isDataTableLoading 	= false;
						}, false);

						gThat.currentActiveTab = 'deleted';
					}
				break;
			}
		}
	},
};
</script>
